// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","690":"4f3b99f8","763":"ab63e4b9"}[chunkId] + ".css";
};